export const SEND_PALLETS_EXCEL_ROW_FIELDS = {
   SEND_DATE: 'sendDate',
   EXTERNAL_COMMERCIAL_NETWORK_NUMBER: 'externalCommercialNetworkNumber',
   COMMERCIAL_NETWORK_NAME: 'commercialNetworkName',
   COMMERCIAL_NETWORK_ADDRESS: 'commercialNetworkAddress',
   PALLET_TYPE: 'palletType',
   PALLETS_AMOUNT: 'palletsAmount',
} as const;
